import { NgModule }           from '@angular/core';
import { SubsectionsService } from './subsections.service';

@NgModule({
  providers: [SubsectionsService]
})
export class SubsectionModule { }
